"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function withWixRequired(Wix) {
    if (!Wix || !Wix.Styles) {
        throw new Error("\n    Wix is required to get default params.\n    Get default params for color or font is possible only at Widget Settings iframe.\n      ");
    }
}
exports.withWixRequired = withWixRequired;
//# sourceMappingURL=withWixRequired.js.map